import parse from 'html-react-parser'
import dynamic from 'next/dynamic'
import Header from '../components/header'
const Footer = dynamic(() => import('../components/footer'))
import Catalogues from '../components/catalogues/catalogues'
import { useSelector } from 'react-redux';
import { React, useState, useEffect } from 'react'
import MetaTags from '../components/MetaTags'
const MiniCart = dynamic(() => import('../components/cart/minicart'))

function CatalogPage({ item, menu, config, list }) {

    const [stored_list, set_stored_list] = useState(list);

    const user = useSelector((state) => state.user);
    var token = false
    var merchant = false
    if (user[0] != undefined) {
        token = user[0].token
        if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
            merchant = true
        }
    }


    useEffect(() => {

        if (merchant) {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
            fetch(
                process.env.NEXT_PUBLIC_API_URL + '/catalogues/merchant',
                {
                    headers: headers,
                    method: 'POST'
                }
            ).then(response => {
                // reject not ok response
                if (!response.ok) {
                    return Promise.reject(response)
                }
                return response.json() // or return response.text()
            })
                .catch(async response => {
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                })
                .then(data => {
                    // take the original list, and append this info to it
                    var newlist = { ...list }
                    newlist.data = list.data.concat(data.data.data)
                    set_stored_list(newlist)
                })
                .catch((error) => {
                    console.warn(error);
                });
        }
    }, [token, merchant, list]);

    return (
        <>
            <MetaTags item={item} config={config}></MetaTags>
            <div className="wrapper h-full flex flex-col">
                <Header menu={menu} config={config}></Header>
                <section className="content flex flex-grow flex-col">
                    <div className="">
                        <div className="container mx-auto text-xs py-2 px-5 lg:px-0">
                            <div className="space-x-2 flex items-center leading-none">
                                <i className="fas fa-home"></i> <span className="text-gray-500">/</span> <span className="text-gray-500">Catalogues</span>
                            </div>
                        </div>
                    </div>
                    <div className="py-8 lg:py-16">
                        <div className="container mx-auto lg:mb-4 lg:px-0 px-5">
                            <h1 className="font-bold text-4xl text-gray-900 mb-8">Catalogues</h1>

                            {(item && item.description) ? (
                                parse(item.description)
                            ) : ('')}

                            <div className="flex justify-center">
                                <div className="lg:w-11/12 grid lg:grid-cols-2 grid-cols-1 gap-6">
                                    <Catalogues list={stored_list}></Catalogues>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer menu={menu} config={config}></Footer>
            </div>
            <MiniCart></MiniCart>
        </>
    )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
    const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
    const config_data = await config_res.json()
    const config = config_data.data

    const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
    const menu = await menu_res.json()

    const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/catalogues')
    const response = await res.json()
    const page = response.data

    const list_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/catalogues')
    const list_response = await list_res.json()
    const list = list_response.data



    return {
        props: {
            config: config,
            menu: menu,
            item: page,
            list: list,
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
            revalidate: 600, // In seconds
    
    }
}


export default CatalogPage